module.exports = {"310120001":"西渡街道","310120002":"奉浦街道","310120101":"南桥镇","310120102":"奉城镇","310120104":"庄行镇","310120106":"金汇镇","310120109":"四团镇","310120111":"青村镇","310120118":"柘林镇","310120123":"海湾镇","310120503":"上海市奉贤区海湾旅游区","310120504":"金海社区","310120505":"上海海港综合经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/310120.json
// module id = 760
// module chunks = 0